import request from '@/utils/request'

// 修改平台用户
export function updateUser(data) {
    return request({
        url: '/h5/user',
        method: 'put',
        data: data
    })
}


// 修改基本资料
export function updateBaseInfo(data) {
    return request({
        url: '/h5/user/updateBaseInfo',
        method: 'put',
        data: data
    })
}


// 修改身份证资料
export function updateIdCardInfo(data) {
    return request({
        url: '/h5/user/updateIdCardInfo',
        method: 'put',
        data: data
    })
}


// 查询用户信息详情
export function getUserInfo(id) {
    return request({
        url: '/h5/user/' + id,
        method: 'get',
    })
}

// 获取活动参与信息
export function getUserJoinInfo() {
    return request({
        url: '/h5/user/getUserJoinInfo',
        method: 'get',
    })
}


// 刷新网银认证
export function getRefreshBankUrl() {
    return request({
        url: '/h5/user/getRefreshBankUrl',
        method: 'post',
    })
}
